<template>
  <div>
    <div v-if="error" class="alert alert-danger">
      <p class="errors">
        {{ error }}
      </p>
    </div>
    <div class="form-inline">
      <select
        class="form-control"
        :value="fieldset"
        name="fieldset"
        style="width: 66%"
        @change="handleChange"
      >
        <option value="">
          Select a Field
        </option>
        <option v-for="($fieldset, exportTag) in sourceFieldsets" :key="exportTag" :value="$fieldset.export_tag">
          {{ $fieldset.label }}
        </option>
      </select>

      <template v-if="fieldIsMultipleChoice">
        is one of
        <div v-for="(label, value) in selectedFieldset.choices" style="padding: 5px;">
          <label>
            <input v-model="comparatorChoices" :value="value" type="checkbox">
            {{ label }}
          </label>
        </div>
      </template>
      <template v-else>
        <span v-if="fieldsForDropdown.length > 1">
          <select :value="exportTag" name="exportTag" class="form-control" @change="handleChange">
            <option disabled :value="null">Select field</option>
            <option v-for="field in fieldsForDropdown" :value="field.name">{{ field.name }}</option>
          </select>
        </span>

        <template v-if="fieldIsBool">
          is
          <select class="form-control" :value="comparator" name="comparator" @change="handleChange">
            <option :value="null">
              Select one
            </option>
            <option value="true">
              True
            </option>
            <option value="false">
              False
            </option>
          </select>
        </template>

        <template v-else-if="fieldIsDecode">
          <div class="form-group">
            is one of
            <div v-for="(label, value) in selectedFieldset.choices" style="padding: 5px;">
              <label>
                <input v-model="comparatorChoices" :value="value" type="checkbox">
                {{ value }}
              </label>
            </div>
          </div>
        </template>

        <template v-else>
          <select
            v-if="fieldset"
            class="form-control"
            :value="operator"
            name="operator"
            @change="handleChange"
          >
            <option value="">
              Select Operator
            </option>
            <optgroup v-if="fieldIsNumeric" label="Numeric">
              <option value="lt">
                &lt;
              </option>
              <option value="lte">
                ≤
              </option>
              <option value="gt">
                &gt;
              </option>
              <option value="gte">
                ≥
              </option>
              <option value="eq">
                =
              </option>
              <option value="neq">
                ≠
              </option>
            </optgroup>
            <optgroup v-if="fieldIsDate" label="Date">
              <option value="dateEquals">
                Equals
              </option>
              <option value="dateIsBefore">
                Is Before
              </option>
              <option value="dateIsAfter">
                Is After
              </option>
            </optgroup>
            <optgroup v-if="fieldIsText" label="Text">
              <option value="contains">
                Contains
              </option>
              <option value="doesNotContain">
                Does Not Contain
              </option>
              <option value="startsWith">
                Starts With
              </option>
              <option value="endsWith">
                Ends With
              </option>
              <option value="textEquals">
                Equals
              </option>
              <option value="textDoesNotEqual">
                Does Not Equal
              </option>
              <option value="textEmpty">
                Is Empty
              </option>
              <option value="textNotEmpty">
                Is Not Empty
              </option>
            </optgroup>
          </select>
          <input
            v-if="fieldIsNumeric"
            class="form-control"
            type="number"
            :value="comparator"
            name="comparator"
            @input="handleChange"
          >
          <b-form-datepicker v-if="fieldIsDate" v-model="displayDate" placeholder="Select a date" @input="updateDate" />
          <input
            v-if="fieldIsText && operatorTakesArgs"
            class="form-control"
            :value="comparator"
            name="comparator"
            @input="handleChange"
          >
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import {BFormDatepicker} from 'bootstrap-vue';
import {unaryOperators} from "@/EventLogic/operators";

export default {
  components: {
    BFormDatepicker,
  },
  props: {
    sourceFieldsets: {
      type: Object,
        default: () => { return {}; }
    },
    fieldset: {
      type: String,
      default: ""
    },
    operator: {
      type: String,
      default: ""
    },
    comparator: {
      type: [String, Array],
      default: ""
    },
    exportTag: {
      type: [String],
      default: ""
    }
  },
  data: function () {
    return {
      comparatorChoices: Array.isArray(this.comparator) ? this.comparator : [],
      displayDate: !Array.isArray(this.comparator) ? this.comparator : "",
      error: false
    }
  },
  computed: {
    selectedFieldset: function () {
      // returns undefined if not selected or doesn't exist in source
      return this.sourceFieldsets[this.fieldset];
    },
    selectedField: function () {
      // returns undefined if not selected or doesn't exist in array
      return this.fieldsForDropdown.find(field => field.name === this.exportTag);
    },
    fieldsForDropdown: function () {
      // don't let multiple choice fieldsets return their fields
      if (!this.selectedFieldset || this.fieldIsMultipleChoice) {
        return [];
      }
      return this.selectedFieldset
          .fields;
      // .filter(field => field.type === 'number');
    },
    fieldIsNumeric: function () {
      return this.fieldIsOfType(['number']);
    },
    fieldIsText: function () {
      return this.fieldIsOfType(['string']);
    },
    fieldIsMultipleChoice: function () {
      if (this.selectedFieldset !== undefined) {
        if (this.selectedFieldset.choices !== undefined) {
          let type = this.selectedFieldset.fields.length === 1 ?
              this.selectedFieldset.fields[0].type
              : this.selectedFieldset.type;
          return type === 'decode';
        }
      }
      return false;
    },
    fieldIsBool: function () {
      return this.fieldIsOfType(['bool']);
    },
    fieldIsDate: function () {
      return this.fieldIsOfType(['date', 'datetime']);
    },
    fieldIsDecode: function () {
      // NLU/intent has a type of decode
      return this.fieldIsOfType(['decode']);
    },
    operatorTakesArgs: function () {
      return unaryOperators.includes(this.operator) === false;
    }
  },
  watch: {
    comparatorChoices: function () {
      this.$emit('update:comparator', this.comparatorChoices);
    },
    selectedFieldset: function () {
      // set operator for multi-choice fields
      if (this.fieldIsMultipleChoice) {
        this.$emit('update:operator', 'isOneOf');
      } else if (this.fieldIsBool) {
        this.$emit('update:operator', 'eq');
      }
    }
  },
  methods: {
    fieldIsOfType: function (types) {
      if (this.selectedFieldset) {
        if (this.fieldsForDropdown.length > 1) {
          if (this.exportTag) {
            return types.includes(this.selectedField.type);
          }
        } else {
          return types.includes(this.selectedFieldset.type);
        }
      }

      return false;
    },
    updateDate: function (val) {
      let date = new Date(val);
      this.$emit('update:comparator', date.toISOString().split('T')[0]);
    },
    handleChange: function (event) {
      let name = event.target.name;
      if (name === 'fieldset') {
        this.$emit('update:comparator', null);
        this.$emit('update:operator', null);
        this.$emit('update:exportTag', null);
        this.displayDate = "";
        this.comparatorChoices = [];
      } else if (name === 'exportTag') {
        let subQuestion = this.selectedFieldset.fields.find(f => f.name === event.target.value);
        if (subQuestion.type === 'decode') {
          this.$emit('update:operator', 'isOneOf');
        }
      }
      this.$emit('update:' + name, event.target.value);
    },
    validate: function () {
      this.error = false;

      if (!this.fieldset) {
        this.error = 'Please select a Field.';
      } else {
        if (this.fieldsForDropdown.length > 1 && !this.exportTag) {
          this.error = 'Please select a Field.';
        } else if (this.fieldIsMultipleChoice) {
          if (this.comparator.length < 1) {
            this.error = "Please select at least one valid choice.";
          }
        } else {
          if (!this.operator && !this.fieldIsBool && !this.fieldIsDecode) {
            this.error = "Please select a comparison operator.";
          } else if (this.operatorTakesArgs && (!this.comparator || !this.comparator.length)) {
            this.error = "Please select something to compare against.";
          }
        }
      }
      return this.error;
    }
  }
};
</script>
